export default function form() {

    const form = document.querySelector('.js-form');

    if (!form) return;

    const formSuccess = form.querySelector('.js-form-success');
    const formSuccessClose = form.querySelector('.js-form-success-close');
    const submitButton = form.querySelector('[type="submit"]');
    let isSending = false;

    form.addEventListener('submit', async function(e) {
        e.preventDefault();

        if (isSending || !form.checkValidity()) {
            form.reportValidity();
            return;
        }

        isSending = true;
        if (submitButton) submitButton.disabled = true;

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                headers: {
                    'Accept': 'application/json',
                },
            });

            const result = await response.json();

            if (response.ok && result.success) {
                formSuccess?.classList.add('active');
                form.reset();
                return;
            }

            console.error('Ошибка отправки формы:', result.error || result.info || result);
        } catch (error) {
            console.error('Ошибка запроса формы:', error);
        } finally {
            isSending = false;
            if (submitButton) submitButton.disabled = false;
        }
    });

    if (formSuccessClose && formSuccess) {
        formSuccessClose.addEventListener('click', function(e) {
            e.preventDefault();
            formSuccess.classList.remove('active');
        });
    }

}
